import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/*
 * AlertModal Component
 * Purpose: Provides a generic, simple dialog box
 * Notes: Dependent components must provide title (alertTitle), body text
 *        (alertText), accept button caption (acceptCaption), reject button
 *        caption (rejectText), and event handlers. Also, the provideReject
 *        prop (a bool) indicates if there is a reject button (i.e. false if
 *        the dialog is to contain only 'OK' button.)
 */
class AlertModal extends Component {
  renderAlertText = () => {
    const { alertText } = this.props;
    const alertText_splitLines = alertText
      .split(/\r\n|\r|\n/g)
      .map((at, i) => <p key={`alertParaKey_${i}`}>{at}</p>);
    return alertText_splitLines;
  };

  render() {
    const {
      alertTitle,
      alertTitleClass,
      alertTitleIcon,
      acceptCaption,
      acceptClass,
      rejectCaption,
      rejectClass,
      provideReject,
      handleAlertAction,
      toggleAlertModal,
      showAlertModal,
      errorId,
    } = this.props;
    return (
      <Modal isOpen={showAlertModal} size={"md"} fade={false}>
        <ModalHeader className={alertTitleClass}>
          {alertTitleIcon && <FontAwesomeIcon icon={alertTitleIcon} className="mr-2" />}
          {alertTitle}
        </ModalHeader>
        <ModalBody>{this.renderAlertText()}</ModalBody>
        <ModalFooter className="bg-lightgray">
          <Button
            color={acceptClass}
            onClick={(e) => {
              const result = handleAlertAction("accept", errorId);
              if (typeof result === "function") result(e);
            }}
          >
            {acceptCaption}
          </Button>{" "}
          {provideReject && (
            <Button
              color={rejectClass}
              onClick={(e) => {
                const result = handleAlertAction("reject");
                if (typeof result === "function") result(e);
              }}
            >
              {rejectCaption}
            </Button>
          )}
        </ModalFooter>
      </Modal>
    );
  }
}

export default AlertModal;
